import axios from '@/service';

const AdminService = {
  getCompanies() {
    return axios.get('admin/companies');
  },
  getCompanySubscription(companyId) {
    return axios.get(`admin/companies/${companyId}/subscription`);
  },
  loginAs(companyId) {
    return axios.post('auth/login-adm', { company_id: companyId }, { headers: { 'Company-Id': companyId } });
  },
  getResellers() {
    return axios.get('admin/resellers');
  },
  getDistributors() {
    return axios.get('admin/distributors');
  },
  getDistributorRecipientDetails(distributorId) {
    return axios.get(`admin/distributors/${distributorId}/recipient_details`);
  },
  getMyRecipientDetails() {
    return axios.get('admin/me/recipient_details');
  },
  getDashboard({ year, compareYear } = {}) {
    const params = {};

    if (year) {
      params.year = year;
    }

    if (compareYear) {
      params.compare_year = compareYear;
    }

    return axios.get('admin/dashboard', { params });
  },
};

export default AdminService;
